module.exports = __webpack_public_path__ + "img/qingyang-34cbcb.png";